<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.bookBundleList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="">{{$t('form.book.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="detailedSearch">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="">{{$t('form.book.description')}}</label>
                                    <textarea type="text" v-model="search.Description" @keyup="searchBookBundle"
                                        class="form-control" rows="5"></textarea>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="">{{$t('form.book.creationDate')}}</label>
                                    <input type="date" v-model="search.CreatedOn" @change="searchBookBundle"
                                        class="form-control">
                                </div>
                            </div>
                            <div class="col-12">
                                <hr>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('form.book.presetName')">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.bookBundleList')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="book_list.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.book.description')}}</th>
                                    <th>{{$t('form.book.creationDate')}}</th>
                                    <th class="text-right">{{$t('form.book.action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(book, index) in book_list" v-bind:key="index">
                                <tr @dblclick="goToEdit(book.ID)">
                                    <td>{{book.Description}}</td>
                                    <td>{{book.CreatedOn | formatDate(dateFormat)}}</td>

                                    <td class="text-right">
                                        <button v-if="permissions.viewBookbundles" class="btn btn-info btn btn-sm"
                                            @click="goToEdit(book.ID)">
                                            <span class="fa fa-edit"></span>
                                        </button>

                                        <button v-if="permissions.deleteBookbundles" class="btn btn-danger btn btn-sm"
                                            @click="deleteBookBundle(index)">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                presetSelected: false,
                detailedSearch: false,

                pagination: {
                    current_page: 1
                },

                search: {},
                preset: {
                    name: '',
                    entity: 'bookBundle',
                    value: {}
                },

                presetList: [],
                book_list: [],
            }
        },

        mounted() {
            this.isLoading = true;
            
            if (!this.permissions.viewBookbundles) {
                this.$router.push('/');
                return;
            }

            if (localStorage.getItem('filter-bookbundle')) {
                this.search = JSON.parse(localStorage.getItem('filter-bookbundle'));
            }

            this.getBookBundle();
            this.getPresets();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-bookbundle', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {
            getBookBundle() {
                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                this.isLoading = true;
                axios.get('/api/bookbundles?page=' + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.book_list = response.data.data.data;
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {

                        console.log(error);
                    });
            },

            paginate() {
                this.getBookBundle();
            },

            clearSearch() {
                this.search = {};
                this.searchBookBundle();
            },

            searchBookBundle() {
                this.pagination.current_page = 1;
                this.getBookBundle();
            },

            goToEdit(id) {
                if (!this.permissions.viewBookbundles) return;

                this.$router.push({
                    name: 'BookBundleEdit',
                    params: {
                        id: id
                    }
                });
            },

            deleteBookBundle(index) {
                if (!this.permissions.deleteBookbundles) return;

                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    var id = this.book_list[index].ID;

                    this.isLoading = true;
                    axios
                        .delete('/api/bookbundles/' + id)
                        .then(response => {
                            this.book_list.splice(index, 1);
                            this.isLoading = false;
                            this.getBookBundle();
                            this.showAlert(response.data.message);
                        })
                        .catch(error => {
                            this.isLoading = false;
                            console.log(error);
                        });
                }
            },

            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.search = {};
                    this.preset = {
                        entity: 'bookBundle'
                    };
                    this.searchBookBundle();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchBookBundle();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.search = {};
                                this.searchBookBundle();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
<style scoped>

</style>
